



export const getAddresses = state => state.get('addresses');

export const getAddress = (state, addressID) => state.getIn(['addresses', addressID]);

export default getAddresses;
